(() => {
  /* EP2 Gift Card (Modern Redesign) */

  const TONES = {
    onyx: {
      name: "ONYX",
      a: "rgba(255,255,255,.16)",
      b: "rgba(120,180,255,.18)",
      c: "rgba(255,140,210,.14)",
      accent: "rgba(255,255,255,.86)",
      oa: "rgba(255,255,255,.16)",
      ob: "rgba(120,180,255,.14)",
      oaccent: "rgba(255,255,255,.86)",
    },
    champagne: {
      name: "CHAMPAGNE",
      a: "rgba(255,255,255,.18)",
      b: "rgba(255,220,140,.20)",
      c: "rgba(255,160,220,.12)",
      accent: "rgba(255,225,160,.92)",
      oa: "rgba(255,255,255,.16)",
      ob: "rgba(255,220,140,.18)",
      oaccent: "rgba(255,225,160,.92)",
    },
    amethyst: {
      name: "AMETHYST",
      a: "rgba(255,255,255,.14)",
      b: "rgba(170,120,255,.22)",
      c: "rgba(255,140,210,.14)",
      accent: "rgba(200,160,255,.92)",
      oa: "rgba(170,120,255,.18)",
      ob: "rgba(255,140,210,.12)",
      oaccent: "rgba(200,160,255,.92)",
    },
    emerald: {
      name: "EMERALD",
      a: "rgba(255,255,255,.14)",
      b: "rgba(90,220,170,.22)",
      c: "rgba(120,180,255,.14)",
      accent: "rgba(120,240,195,.92)",
      oa: "rgba(90,220,170,.18)",
      ob: "rgba(120,180,255,.12)",
      oaccent: "rgba(120,240,195,.92)",
    },
    steel: {
      name: "STEEL",
      a: "rgba(255,255,255,.14)",
      b: "rgba(190,210,235,.18)",
      c: "rgba(120,180,255,.12)",
      accent: "rgba(210,225,245,.92)",
      oa: "rgba(190,210,235,.16)",
      ob: "rgba(255,255,255,.10)",
      oaccent: "rgba(210,225,245,.92)",
    },
    crimson: {
      name: "CRIMSON",
      a: "rgba(255,255,255,.14)",
      b: "rgba(255,110,140,.22)",
      c: "rgba(255,210,120,.12)",
      accent: "rgba(255,150,170,.92)",
      oa: "rgba(255,110,140,.18)",
      ob: "rgba(255,210,120,.12)",
      oaccent: "rgba(255,150,170,.92)",
    },
  };

  function prefersReduced() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function localISODateToday() {
    const d = new Date();
    const tz = d.getTimezoneOffset() * 60000;
    return new Date(d.getTime() - tz).toISOString().slice(0, 10);
  }

  function safeJSON(str) {
    try { return JSON.parse(str); } catch { return []; }
  }

  function escapeHTML(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function formatTRDate(iso) {
    const parts = String(iso || "").split("-");
    if (parts.length === 3) return `${parts[2]}.${parts[1]}.${parts[0]}`;
    return iso;
  }

  // ✅ Tone normalize (onyx/Onyx/ONYX -> onyx)
  function toneKeyOf(item) {
    const raw = String(item?.tone || "onyx").trim().toLowerCase();
    return TONES[raw] ? raw : "onyx";
  }

  function setToneVars(section, toneKey) {
    const t = TONES[toneKey] || TONES.onyx;
    section.style.setProperty("--t-a", t.a);
    section.style.setProperty("--t-b", t.b);
    section.style.setProperty("--t-c", t.c);
    section.style.setProperty("--t-accent", t.accent);
    section.style.setProperty("--t-name", `"${t.name}"`);
  }

  function buildOptionEl(item, idx, selected) {
    const toneKey = toneKeyOf(item);
    const t = TONES[toneKey] || TONES.onyx;

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "ep2gc2-opt";
    btn.setAttribute("role", "radio");
    btn.setAttribute("aria-checked", selected ? "true" : "false");
    btn.setAttribute("data-ep2gc2-index", String(idx));

    btn.style.setProperty("--o-a", t.oa);
    btn.style.setProperty("--o-b", t.ob);
    btn.style.setProperty("--o-accent", t.oaccent);

    // ✅ Tik işareti kaldırıldı
    btn.innerHTML = `
      <div class="ep2gc2-optTop">
        <span class="ep2gc2-optBadge">ESPINA</span>
        <span class="ep2gc2-optRadio" aria-hidden="true"></span>
      </div>
      <h4 class="ep2gc2-optTitle">${escapeHTML(item.title || "Gift Card")}</h4>
      <p class="ep2gc2-optPrice">${escapeHTML(item.priceText || "—")}</p>
    `;
    return btn;
  }

  function initSection(section) {
    const ui = section.querySelector("[data-ep2gc2-items]");
    if (!ui) return;

    const items = safeJSON(ui.getAttribute("data-ep2gc2-items") || "[]")
      .filter(x => x && x.variantId);

    if (!items.length) return;

    // UI nodes
    const heroShell = section.querySelector("[data-ep2gc2-hero-shell]");
    const heroTitle = section.querySelector("[data-ep2gc2-hero-title]");
    const heroPrice = section.querySelector("[data-ep2gc2-hero-price]");
    const heroTone = section.querySelector("[data-ep2gc2-hero-tone]");
    const summary = section.querySelector("[data-ep2gc2-summary]");
    const options = section.querySelector("[data-ep2gc2-options]");

    const dateInput = section.querySelector("#ep2gc2-date");
    const dateTag = section.querySelector("[data-ep2gc2-dateTag]");
    const continueBtn = section.querySelector("[data-ep2gc2-continue]");

    const formDrawer = document.querySelector('[data-ep2gc2-drawer="form"]');
    const infoDrawer = document.querySelector('[data-ep2gc2-drawer="info"]');
    const infoOpen = section.querySelector("[data-ep2gc2-info-open]");

    // hidden inputs
    const variantInput = formDrawer?.querySelector("[data-ep2gc2-variant-id]");
    const propDate = formDrawer?.querySelector("[data-ep2gc2-prop-date]");
    const propSendOn = formDrawer?.querySelector("[data-ep2gc2-prop-send-on]");
    const propTitle = formDrawer?.querySelector("[data-ep2gc2-prop-title]");
    const propPrice = formDrawer?.querySelector("[data-ep2gc2-prop-price]");
    const modalSub = formDrawer?.querySelector("[data-ep2gc2-modal-sub]");

    // Date default/min
    const today = localISODateToday();
    if (dateInput) {
      dateInput.min = today;
      if (!dateInput.value) dateInput.value = today;
    }

    // State
    let selectedIndex = items.findIndex(i => i.isDefault);
    if (selectedIndex < 0) selectedIndex = 0;

    function selectedItem() {
      return items[selectedIndex] || null;
    }

    function updateDateTag() {
      if (!dateInput || !dateTag) return;
      const v = dateInput.value || today;
      dateTag.textContent = (v === today) ? "Bugün" : formatTRDate(v);
    }

    function updateModalSubPreview() {
      const it = selectedItem();
      const raw = dateInput?.value || today;
      if (!it) return;

      const formatted = formatTRDate(raw);
      const p = it.priceText ? ` · ${it.priceText}` : "";

      if (modalSub) {
        modalSub.textContent = `Seçili kart: ${it.title || "Gift Card"}${p} · Teslim tarihi: ${formatted}`;
      }
    }

    function renderHero(animate = true) {
      const it = selectedItem();
      if (!it) return;

      const toneKey = toneKeyOf(it);
      setToneVars(section, toneKey);

      if (heroTitle) heroTitle.textContent = it.title || "Gift Card";
      if (heroPrice) heroPrice.textContent = it.priceText || "—";

      // ✅ Artık seçilen karta göre değişir (ONYX sabit kalmaz)
      if (heroTone) heroTone.textContent = (TONES[toneKey]?.name || toneKey.toUpperCase());

      if (summary) {
        const p = it.priceText ? ` · ${it.priceText}` : "";
        summary.textContent = `Seçili kart: ${it.title || "Gift Card"}${p}`;
      }

      if (variantInput) variantInput.value = it.variantId || "";
      if (propTitle) propTitle.value = it.title || "";
      if (propPrice) propPrice.value = it.priceText || "";

      if (heroShell && animate && !prefersReduced()) {
        heroShell.animate(
          [
            { transform: "translateY(0px) scale(1)", filter: "blur(0px)", opacity: 1 },
            { transform: "translateY(-2px) scale(1.01)", filter: "blur(0px)", opacity: 1 },
            { transform: "translateY(0px) scale(1)", filter: "blur(0px)", opacity: 1 }
          ],
          { duration: 260, easing: "cubic-bezier(.2,.9,.2,1)" }
        );
      }
    }

    function renderOptions() {
      if (!options) return;
      options.innerHTML = "";
      items.forEach((it, idx) => {
        const el = buildOptionEl(it, idx, idx === selectedIndex);
        options.appendChild(el);
      });
    }

    function setSelected(newIndex) {
      if (newIndex < 0 || newIndex >= items.length) return;
      if (newIndex === selectedIndex) return;

      selectedIndex = newIndex;

      // update aria-checked without full repaint
      if (options) {
        options.querySelectorAll(".ep2gc2-opt").forEach(btn => {
          const i = Number(btn.getAttribute("data-ep2gc2-index") || "-1");
          btn.setAttribute("aria-checked", i === selectedIndex ? "true" : "false");
        });
      }

      renderHero(true);
      updateModalSubPreview();
    }

    // Drawer helpers
    function openDrawer(which) {
      const d = which === "info" ? infoDrawer : formDrawer;
      if (!d) return;
      d.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
    }

    function closeDrawer(which) {
      const d = which === "info" ? infoDrawer : formDrawer;
      if (!d) return;
      d.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
    }

    // Events
    if (options) {
      options.addEventListener("click", (e) => {
        const btn = e.target?.closest?.(".ep2gc2-opt");
        if (!btn) return;
        const idx = Number(btn.getAttribute("data-ep2gc2-index"));
        if (Number.isFinite(idx)) setSelected(idx);
      });

      options.addEventListener("keydown", (e) => {
        const active = document.activeElement;
        if (!active || !active.classList?.contains("ep2gc2-opt")) return;

        const idx = Number(active.getAttribute("data-ep2gc2-index") || selectedIndex);
        let next = idx;

        if (e.key === "ArrowRight" || e.key === "ArrowDown") next = Math.min(items.length - 1, idx + 1);
        if (e.key === "ArrowLeft" || e.key === "ArrowUp") next = Math.max(0, idx - 1);

        if (next !== idx) {
          e.preventDefault();
          setSelected(next);
          const nextBtn = options.querySelector(`.ep2gc2-opt[data-ep2gc2-index="${next}"]`);
          nextBtn?.focus?.();
        }
      });
    }

    if (dateInput) {
      dateInput.addEventListener("change", () => {
        const raw = dateInput.value || today;
        if (propDate) propDate.value = raw;
        if (propSendOn) propSendOn.value = raw;
        updateDateTag();
        updateModalSubPreview();
      });
    }

    document.querySelectorAll("[data-ep2gc2-close]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const which = btn.getAttribute("data-ep2gc2-close");
        closeDrawer(which);
      });
    });

    if (infoOpen) infoOpen.addEventListener("click", () => openDrawer("info"));

    if (continueBtn) {
      continueBtn.addEventListener("click", () => {
        const it = selectedItem();
        if (!it || !it.variantId) {
          alert("Lütfen bir Gift Card seçin.");
          return;
        }

        if (dateInput && !dateInput.value) dateInput.value = today;
        const raw = dateInput?.value || today;

        if (propDate) propDate.value = raw;
        if (propSendOn) propSendOn.value = raw;

        updateDateTag();
        updateModalSubPreview();
        openDrawer("form");
      });
    }

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closeDrawer("form");
        closeDrawer("info");
      }
    });

    // Initial render
    renderOptions();
    renderHero(false);
    updateDateTag();
    updateModalSubPreview();
  }

  function boot() {
    document.querySelectorAll("[data-ep2gc2-section]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
